<template>
  <div class="w-full h-full pt-5">
    <div class="flex mb-8 px-5">
      <h1 class="text-xl text-left font-extrabold mr-4">13th Month Pay</h1>
      <breadcrumb :items="breadcrumbs" />
    </div>
    <div class="px-3">
      <card class="p-5">
        <div class="mx-2 mt-3">
          <Tab
            :tabs="tabs"
            border
            :active-tab="currentTab"
            @currentTab="currentTab = $event"
            v-model="currentTab"
          />
          <div>
            <div>
              <Card class="mt-6 p-5">
                <div>
                  <div class="flex mb-6" style="justify-content: flex-end">
                    <Button
                      class="bg-dynamicBackBtn text-white"
                      @click="processPayRun()"
                    >
                      New Payrun
                    </Button>
                    <Button
                      class="bg-white ml-4 text-dynamicBackBtn border border-solid border-dynamicBackBtn"
                      style-name="width: 180px"
                      options
                      :width="`auto`"
                      :disabled="false"
                      :option-list="[
                        'Terminal Pay',
                        'Back Pay',
                        'Back to Regular Payrun',
                      ]"
                      @click="buttonOptionSelected($event)"
                    >
                      13th Month Pay
                    </Button>
                  </div>
                </div>
                <template v-slot:footer>
                  <card-footer v-if="!showError" :show-bulk-actions="false" />
                </template>
              </Card>
            </div>


            <div class="pt-3">
              <sTable
                :headers="thirteenthMonthPayHeaders"
                :items="payrunItems"
                v-if="payrunItems.length > 0 || loading"
                style="width:100%; height:auto"
                class="w-full"
                aria-label="payrun table"
                :loading="loading"
                :has-checkbox="false"
                :has-number="false"
                :pagination-list="metaData"
                @page="handlePage($event)"
                @itemsPerPage="handleItemsPerPage($event)"
                page-sync
              >
                <template v-slot:item="{ item }">
                  <span v-if="item.year" style="width: 189px">
                    {{
                      `${$DATEFORMAT(
                        new Date(item.data.year, item.data.month - 1, 1),
                        "LLLL"
                      )} ${item.data.year}`
                    }}
                  </span>
                  <div v-else-if="item.payFrequency">
                    {{ handlePayFrequency(item.data.payFrequency) }}
                  </div>
                  <div class="capitalize" v-else-if="item.payType">
                    {{ item.data.payType }}
                  </div>
                  <div class="" v-else-if="item.paySplitPosition">
                    {{ `${$getOrdinal(item.data.paySplitPosition)} Payment` }}
                  </div>

                  <span v-else-if="item.paidDate">
                    {{ item.data.paidDate }}
                  </span>
                  <span v-else-if="item.paidAt">
                    {{
                      item.data.paidAt
                        ? $DATEFORMAT(new Date(item.data.paidAt), "yyyy-MM-dd")
                        : "-"
                    }}
                  </span>
                  <span v-else-if="item.createdAt">
                    {{
                      item.data.createdAt
                        ? $DATEFORMAT(
                            new Date(item.data.createdAt),
                            "yyyy-MM-dd"
                          )
                        : "-"
                    }}
                  </span>
                  <span v-else-if="item.paymentReferrenceId">
                    {{ item.data.paymentReferrenceId }}
                  </span>
                  <span v-else-if="item.bankName">
                    {{ toTitleCase(item.data.bankName) }}
                  </span>
                  <span v-else-if="item.accountNumber">
                    {{ item.data.accountNumber }}
                  </span>
                  <span v-else-if="item.status">
                    {{ item.data.status }}
                  </span>

                  <span v-else-if="item.type">
                    {{ toTitleCase(item.data.type) }}
                  </span>
                  <span
                    :class="
                      item.data.paymentChannel === 'in-app'
                        ? 'text-mediumSeaGreen'
                        : 'text-darkPurple'
                    "
                    v-else-if="item.paymentChannel"
                  >
                    {{ toTitleCase(item.data.paymentChannel) }}
                  </span>
                  <span v-else-if="item.payDate">
                    {{ item.data.payDate ? item.data.payDate : "-" }}
                  </span>
                  <span v-else-if="item.totalPaye">
                    {{
                      item.data.totalPaye
                        ? convertToCurrency(item.data.totalPaye)
                        : "-"
                    }}
                  </span>
                  <span v-else-if="item.totalPension">
                    {{
                      item.data.totalPension
                        ? convertToCurrency(item.data.totalPension)
                        : "-"
                    }}
                  </span>
                  <span v-else-if="item.grossEarnings">
                    {{
                      item.data.grossEarnings
                        ? convertToCurrency(item.data.grossEarnings)
                        : "-"
                    }}
                  </span>
                  <span v-else-if="item.netEarnings">
                    {{
                      item.data.netEarnings
                        ? convertToCurrency(item.data.netEarnings)
                        : "-"
                    }}
                  </span>
                  <span v-else-if="item.totalCost" class="grosspay">
                    {{
                      item.data.totalCost
                        ? convertToCurrency(item.data.totalCost)
                        : "-"
                    }}
                  </span>
                  <span v-else-if="item.id">
                    <div
                      class="cursor-pointer"
                      v-if="!item.data.editable && currentTab !== 'Approved'"
                      @click="viewDetails(item.data, currentTab)"
                    >
                      <icon
                        icon-name="icon-eye"
                        class-name="text-blueCrayola"
                        size="xs"
                      />
                    </div>
                    <Menu
                      v-if="!item.data.editable && currentTab === 'Approved'"
                      left
                      top="-150"
                      margin="24"
                      class="my-2 p-0"
                    >
                      <template v-slot:title>
                        <icon icon-name="more_icon" size="xs" />
                      </template>
                      <div style="width: 116px; height: 81px" class="py-3 px-2">
                        <div
                          @click="viewDetails(item.data)"
                          class="flex py-1 px-3 more h-8 cursor-pointer"
                        >
                          <icon
                            icon-name="icon-eye"
                            class-name="text-blueCrayola mr-2"
                            size="xsm"
                          />
                          <p class="pt-1">View</p>
                        </div>
                        <div
                          @click="showCancelComponent(item.data.id)"
                          class="flex py-1 px-3 more h-8 cursor-pointer"
                        >
                          <icon
                            icon-name="close-icon"
                            class-name="text-desire mr-2"
                            size="xsm"
                          />
                          <p class="pt-1">Cancel</p>
                        </div>
                      </div>
                    </Menu>
                  </span>
                </template>
              </sTable>

              <div
                class="w-full flex flex-col justify-center items-center mt-10"
                v-else
              >
                <icon
                  icon-name="empty_agreement"
                  size="l"
                  style="width: 300px"
                />
                <div class="w-1/2 text-base text-center">
                  There is no 13th Month Pay to process at this time.
                </div>
              </div>

            </div>
          </div>
        </div>
      </card>
    </div>

    <new-payrun-modal
      :open-modal="openModal"
      @close="handleClose"
    />
  </div>
</template>

<script>
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import Tab from "@scelloo/cloudenly-ui/src/components/tab";
import STable from "@scelloo/cloudenly-ui/src/components/table";
import Card from "@/components/Card";
import Button from "@/components/Button";
import CardFooter from "@/components/CardFooter";
import Menu from "@/components/Menu";

export default {
  name: "Payrun",
  components: {
    Tab,
    Breadcrumb,
    Menu,
    Card,
    Button,
    CardFooter,
    STable,
    NewPayrunModal: () => import("./NewPayrunModal"),
  },
  data() {
    return {
      openModal: false,
      currentTab: this.$route.query.currentTab || "Drafts",
      showError: false,
      annualGrossTotal: 100,
      showCancelModal: false,
      payRunDataId: "",
      modalType: "",
      userId: "",
      metaData: {},
      tabs: [
        "Drafts",
        "Under Review",
        "Approved",
        "Disapproved",
        "Paid",
      ],
      currentText: "Created At",
      payruns: {},
      loading: true,
      selectedEmployees: [],
      loadingBackPay: false,
      payrunItems: [],
      status: "",
      state: "drafts",
      optionSelected: "Back to Regular Payrun",
      breadcrumbs: [
        { disabled: false, text: "Payroll", href: "Payroll", id: "Payroll" },
        { disabled: false, text: "Payrun", href: "Payrun", id: "Payrun" },
        {
          disabled: false,
          text: "Off-Cycle Pay",
          href: "Off Cycle",
          id: "Off-Cycle",
        },
        {
          disabled: false,
          text: "13th Month Pay",
          href: "13th Month Pay",
          id: "13th Month Pay",
        },
      ],
      itemsPerPage: null,
      numberOfPage: null,
      payload: {
        employeeIds: [],
      },
    };
  },

  computed: {
    thirteenthMonthPayHeaders() {
      let headerArry = [];
      if (this.currentTab === "Drafts") {
        headerArry = [
          { title: "PayRun Type", value: "paymentType" },
          { title: "Due Date", value: "payDate" },
          { title: "Gross Earnings", value: "grossEarnings" },
          { title: "Paye", value: "paye" },
          { title: "Pension", value: "totalPension" },
          { title: "Net Earnings", value: "netEarnings" },
          { title: "Total Cost", value: "totalCost" },
          { title: "", value: "id", image: true },
        ];
      } else {
        headerArry = [
          { title: "Pay Run Cycle", value: "year" },
          { title: "Pay type", value: "payType" },
          { title: "Pay frequency", value: "payFrequency" },
          { title: "Pay SCHEDULE", value: "paySplitPosition" },
          {
            title: this.currentTab === "Paid" ? "Pay Date" : "Created At",
            value: this.currentTab === "Paid" ? "paidAt" : "createdAt",
          },
          { title: "Gross Earnings", value: "grossEarnings" },
          { title: "Net Earnings", value: "netEarnings" },
          { title: "Total Cost", value: "totalCost" },
          { title: "", value: "id" },
        ];
        if (this.currentTab === "Paid") {
          headerArry.splice(6, 0, {
            title: "Channel",
            value: "paymentChannel",
          });
        }
      }
      return headerArry;
    },
  },

  watch: {
    currentTab(value) {
      this.checkCurrentTab(value);
      this.$router.push({ query: { currentTab: value } });
    },
    },

    methods: {
        handleClose() {
            this.openModal = false;
        },

        processPayRun() {
            this.openModal = true;
      },

      viewDetails(data) {
        this.$router.push({
          name: '13thMonthPayrun',
          params: {id: data.id}
        })
      },

    checkCurrentTab(value) {
      switch (value) {
        case "Terminated Employees":
          this.terminatedEmployees();
          break;

        case "Drafts":
          this.payrunItems = [];
          this.loading = true;
          this.$_getPayrun("draft", "&page=1&perPage=50", "13th-month").then(
            (result) => {
              this.payrunItems = result.data.payruns;
              this.metaData = result.data.meta;
              this.loading = false;
            }
          );
          break;

        case "Under Review":
          this.loading = true;
          this.$_getPayrun("review", "&page=1&perPage=50", "13th-month").then((result) => {
            this.payrunItems = result.data.payruns;
            this.metaData = result.data.meta;
            this.loading = false;
          });
          break;

        case "Approved":
          this.loading = true;
          this.$_getPayrun("approved", "&page=1&perPage=50", "13th-month").then((result) => {
            this.payrunItems = result.data.payruns;
            this.metaData = result.data.meta;
            this.loading = false;
          });
          break;

        case "Disapproved":
          this.loading = true;
          this.$_getPayrun("disapproved", "&page=1&perPage=50", "13th-month").then(
            (result) => {
              this.payrunItems = result.data.payruns;
              this.metaData = result.data.meta;
              this.loading = false;
            }
          );
          break;

        case "Paid":
          this.loading = true;
          this.$_getPayrun("paid", "&page=1&perPage=50", "13th-month").then((result) => {
            this.payrunItems = result.data.payruns;
            this.metaData = result.data.meta;
            this.loading = false;
          });
          break;

        default:
          break;
      }
    },

    buttonOptionSelected(option) {
      switch (option) {
        case "Back to Regular Payrun":
          this.$router.push({ name: "Pay Runs" });
          break;

        case "Back Pay":
          this.$router.push({ name: "BackPay" });
          break;

        case "Terminal Pay":
          this.$router.push({ name: "terminalPay" });
          break;

        default:
          break;
      }
    },

  },

  mounted() {
    if (this.currentTab === "Drafts") {
      this.$_getPayrun("draft", "&page=1&perPage=50", "13th-month").then(
        (result) => {
          this.payrunItems = result.data.payruns;
          this.metaData = result.data.meta;
          this.loading = false;
        }
      );
    } else if (this.currentTab === "Under Review") {
      this.$_getPayrun("review", "&page=1&perPage=50", "13th-month").then(
        (result) => {
          this.payrunItems = result.data.payruns;
          this.metaData = result.data.meta;
          this.loading = false;
        }
      );
    } else if (this.currentTab === "Approved") {
      this.$_getPayrun("approved", "&page=1&perPage=50", "13th-month").then(
        (result) => {
          this.payrunItems = result.data.payruns;
          this.metaData = result.data.meta;
          this.loading = false;
        }
      );
    } else if (this.currentTab === "Disapproved") {
      this.$_getPayrun("disapproved", "&page=1&perPage=50", "13th-month").then(
        (result) => {
          this.payrunItems = result.data.payruns;
          this.metaData = result.data.meta;
          this.loading = false;
        }
      );
    } else if (this.currentTab === "Paid") {
      this.$_getPayrun("paid", "&page=1&perPage=50", "13th-month").then(
        (result) => {
          this.payrunItems = result.data.payruns;
          this.metaData = result.data.meta;
          this.loading = false;
        }
      );
    }
  },
};
</script>
